// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    PrescriberListRequestModel,
    PrescriberLongResponse,
    PrescriberModelResponse,
    PrescriberModels,
    PrescriberSearchModelResponse,
    PrescriberSearchRequestModel,
    UpsearchModelPrescriberPrescriberUpsearchModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class PrescriberV3Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @summary Gets the Prescriber by Prescriber and Program identifiers.
     * @param prescriberId 
     */
    public async prescriberGetByTenantId (prescriberId: number): Promise<AxiosResponse<PrescriberModelResponse>> {
        const _url_ = '/prescriber/v3/Prescriber/{prescriberId}'
            .replace('{' + 'prescriberId' + '}', encodeURIComponent(String(prescriberId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'prescriberId' is not null or undefined
        if (prescriberId === null || prescriberId === undefined) {
            throw new Error('Required parameter prescriberId was null or undefined when calling prescriberGetByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PrescriberModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriberModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Get a list of Prescriber by Tenant identifier and list of Prescriber identifiers.
     * @param prescriberListRequestModel PrescriberListRequestModel object containing list of Prescriber identifiers
     */
    public async prescriberListByTenantId (prescriberListRequestModel: PrescriberListRequestModel): Promise<AxiosResponse<PrescriberModels>> {
        const _url_ = '/prescriber/v3/PrescriberList';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'prescriberListRequestModel' is not null or undefined
        if (prescriberListRequestModel === null || prescriberListRequestModel === undefined) {
            throw new Error('Required parameter prescriberListRequestModel was null or undefined when calling prescriberListByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(prescriberListRequestModel, "PrescriberListRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PrescriberModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriberModels");
        }
        return response;
    }
    /**
     * 
     * @summary Searches for Prescribers matching criteria.
     * @param prescriberSearchRequestModel PrescriberSearchRequestModel object
     */
    public async prescriberSearchByTenantId (prescriberSearchRequestModel: PrescriberSearchRequestModel): Promise<AxiosResponse<PrescriberSearchModelResponse>> {
        const _url_ = '/prescriber/v3/PrescriberSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'prescriberSearchRequestModel' is not null or undefined
        if (prescriberSearchRequestModel === null || prescriberSearchRequestModel === undefined) {
            throw new Error('Required parameter prescriberSearchRequestModel was null or undefined when calling prescriberSearchByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(prescriberSearchRequestModel, "PrescriberSearchRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PrescriberSearchModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriberSearchModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Upsearch Prescriber
     * @param upsearchModelPrescriberPrescriberUpsearchModel PrescriberUpsearchModel object
     */
    public async prescriberUpsearchByTenantId (upsearchModelPrescriberPrescriberUpsearchModel: UpsearchModelPrescriberPrescriberUpsearchModel): Promise<AxiosResponse<PrescriberLongResponse>> {
        const _url_ = '/prescriber/v3/PrescriberUpsearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'upsearchModelPrescriberPrescriberUpsearchModel' is not null or undefined
        if (upsearchModelPrescriberPrescriberUpsearchModel === null || upsearchModelPrescriberPrescriberUpsearchModel === undefined) {
            throw new Error('Required parameter upsearchModelPrescriberPrescriberUpsearchModel was null or undefined when calling prescriberUpsearchByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(upsearchModelPrescriberPrescriberUpsearchModel, "UpsearchModelPrescriberPrescriberUpsearchModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PrescriberLongResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriberLongResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Get a list of Prescribers by Tenant and Site identifiers
     * @param siteId Site identifier
     */
    public async prescribersBySiteGetByTenantId (siteId: number): Promise<AxiosResponse<PrescriberModels>> {
        const _url_ = '/prescriber/v3/PrescribersBySite/{siteId}'
            .replace('{' + 'siteId' + '}', encodeURIComponent(String(siteId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'siteId' is not null or undefined
        if (siteId === null || siteId === undefined) {
            throw new Error('Required parameter siteId was null or undefined when calling prescribersBySiteGetByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PrescriberModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriberModels");
        }
        return response;
    }
}
